export default {
  GET_ALL_FILTERS: 'getAllFilters',
  GET_FILTER_FULL: 'editFilterFull',
  SAVE_FILTER: 'saveFilter',
  SAVE_FILTER_FULL: 'saveFilterFull',
}
